import { RefObject, useEffect, useRef } from 'react';

import { SegmentClient } from 'lib/clients/SegmentClient';

const SegmentIframe = () => {
  const iframeRef: RefObject<HTMLIFrameElement> = useRef(null);

  useEffect(() => {
    function handleLoad() {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      SegmentClient.setIframe(iframeRef.current);
    }

    iframeRef.current?.addEventListener('load', handleLoad);
    return () => {
      iframeRef.current?.removeEventListener('load', handleLoad);
    };
  }, [iframeRef]);

  useEffect(() => {
    function handleMessageFromSegmentIframe(ev: MessageEvent<{ message: string }>) {
      if (typeof ev.data !== 'object') return;
      if (!ev.data.message) return;

      switch (ev.data.message) {
        case 'segmentIframeLoaded':
          // Don't load from the register/activate page since that immediately redirects to dashboard/home, and erases
          // the iframe.
          if (location.pathname !== '/dashboard/register/activate') {
            SegmentClient.setIsIframeLoaded(true);
          }
          break;
        default:
          return;
      }
    }

    window.addEventListener('message', handleMessageFromSegmentIframe);
    return () => {
      window.removeEventListener('message', handleMessageFromSegmentIframe);
    };
  }, []);

  return (
    <iframe
      id='segment-iframe'
      ref={iframeRef}
      src={import.meta.env.VITE_SEGMENT_IFRAME_URL}
      hidden
    >
      <p>Your browser does not support iframes.</p>
    </iframe>
  );
};

export default SegmentIframe;
